import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHeader, Loading, EmptyState, Avatar } from "@/components/brand";
import dayjs from "dayjs";

export default function Messages() {
  const convos = useQuery({ queryKey: ["conversations"], queryFn: () => api("/conversations"), refetchInterval: 15000 });
  return (
    <div data-testid="messages-screen" className="space-y-5 max-w-2xl">
      <SectionHeader title="Messages" subtitle="Chat with your trainers and clients." />
      {convos.isLoading ? <Loading /> : (convos.data ?? []).length === 0 ? (
        <EmptyState icon={MessageCircle} title="No conversations yet" subtitle="Message a trainer from their profile to start chatting." />
      ) : (
        <div className="space-y-2">
          {(convos.data ?? []).map((c) => (
            <Link key={c.id} to={`/chat/${c.id}`} data-testid={`conversation-${c.id}`} className="flex items-center gap-3 p-3 rounded-xl2 border border-divider hover:border-brand transition-colors">
              <Avatar uri={c.other.avatar} size={48} name={c.other.name} />
              <div className="flex-1 min-w-0">
                <div className="font-display text-base text-ink truncate">{c.other.name}</div>
                <div className="font-body text-sm text-mutedgrey truncate">{c.last_message || "Say hello 👋"}</div>
              </div>
              <div className="flex flex-col items-end gap-1">
                <span className="font-body text-[11px] text-mutedgrey">{c.last_at ? dayjs(c.last_at).format("HH:mm") : ""}</span>
                {c.unread > 0 ? <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-brand text-white text-[11px] font-bold flex items-center justify-center">{c.unread}</span> : null}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
